const state = () => ({
    detail:[], // 每条待处理审批信息的详细数据
    taskName: [], // 审批流程节点信息
    completeStatus: false, // 完成后返回主界面
})
const getters = {}
const mutations = {
    setDetail(state,value){
        state.detail = value
    },
    setTaskName(state,value){
        state.taskName = value
    },
    setCompleteStatus(state,value){
        state.completeStatus = value
    },
}
export default {
    namespaced: true,
    state,
    getters,
    mutations
}
